import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class HttpService {
  // public URL = 'http://3.36.50.41:80';
  // public URL = 'https://onefac-api-prod.cntech.pro';
  // public URL = 'https://onefac-api-poc-dev.cntech.pro';
  // public URL = 'http://127.0.0.1:3000';
  // public URL = 'https://onefac-api-dev.cntech.pro';
  public URL = this.isDevelopment() ? "/api" : 
    window.location.href.split("/")[2] === "smartfactory.cntech.pro"
      ? "https://onefac-api-dev.cntech.pro"
      : "https://onefac-api-dev.cntech.pro";

  private isDevelopment(): boolean {
    return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  }

  constructor(private http: HttpClient, private router: Router) {
    this.URL;
  }

  post(path: string, body?: any, headers?: any, url?: string) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post(`${url || this.URL}${path}`, body, {
          headers: localStorage.getItem("token")
            ? {
                ...headers,
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              }
            : { ...headers },
        })
        .subscribe(
          (data) => resolve(data),
          (error) => {
            reject(error.error || error);
            if (error?.error.message === "JWT expired") {
              localStorage.removeItem("token");
              localStorage.removeItem("companyId");
              localStorage.removeItem("autoLogin");
              localStorage.removeItem("name");
              localStorage.removeItem("position");
              // localStorage.removeItem('logo');
              localStorage.removeItem("checkCompany");
              this.router.navigateByUrl("/account/login");
            }
          }
        );
    });
  }

  get(path: string, url?: string) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .get(`${url || this.URL}${path}`, {
          headers: {
            Authorization: localStorage.getItem("token")
              ? `Bearer ${localStorage.getItem("token")}`
              : null,
          },
        })
        .subscribe(
          (data) => resolve(data),
          (error) => {
            reject(error.error || error);
            if (error?.error.message === "JWT expired") {
              localStorage.removeItem("token");
              localStorage.removeItem("companyId");
              localStorage.removeItem("autoLogin");
              localStorage.removeItem("name");
              localStorage.removeItem("position");
              localStorage.removeItem("checkCompany");
              // localStorage.removeItem('logo');
              this.router.navigateByUrl("/account/login");
            }
          }
        );
    });
  }

  patch(path: string, headers?: any, body?: any, url?: string) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .patch(`${url || this.URL}${path}`, body, {
          headers: {
            ...headers,
            Authorization: localStorage.getItem("token")
              ? `Bearer ${localStorage.getItem("token")}`
              : null,
          },
        })
        .subscribe(
          (data) => resolve(data),
          (error) => {
            reject(error.error || error);
            if (error?.error.message === "JWT expired") {
              localStorage.removeItem("token");
              localStorage.removeItem("companyId");
              localStorage.removeItem("autoLogin");
              localStorage.removeItem("name");
              localStorage.removeItem("position");
              localStorage.removeItem("checkCompany");
              // localStorage.removeItem('logo');
              this.router.navigateByUrl("/account/login");
            }
          }
        );
    });
  }

  delete(path: string, url?: string) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .delete(`${url || this.URL}${path}`, {
          headers: {
            Authorization: localStorage.getItem("token")
              ? `Bearer ${localStorage.getItem("token")}`
              : null,
          },
        })
        .subscribe(
          (data) => resolve(data),
          (error) => {
            reject(error.error || error);
            if (error?.error.message === "JWT expired") {
              localStorage.removeItem("token");
              localStorage.removeItem("companyId");
              localStorage.removeItem("autoLogin");
              localStorage.removeItem("name");
              localStorage.removeItem("position");
              localStorage.removeItem("checkCompany");
              // localStorage.removeItem('logo');
              this.router.navigateByUrl("/account/login");
            }
          }
        );
    });
  }

  uploadFile(item: any, type: "spec" | "check", formData: any) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .post(
          `https://4sajgce8nk.execute-api.ap-northeast-2.amazonaws.com/api/files/company/${
            item.company_id
          }/${item.form_of_product === "items" ? "item" : "parts"}/${
            item.id
          }/${type}`,
          formData
        )
        .subscribe(
          (data) => resolve(data[0].data.Location),
          (error) => reject(error.error || error)
        );
    });
  }

  getX(path: string, headers?: any) {
    return new Promise<any>((resolve, reject) => {
      this.http
        .get(`${this.URL}${path}`, {
          ...headers,
        })
        .subscribe(
          (data) => resolve(data),
          (error) => {
            reject(error.error || error);
            if (error?.error.message === "JWT expired") {
              localStorage.removeItem("token");
              localStorage.removeItem("companyId");
              localStorage.removeItem("autoLogin");
              localStorage.removeItem("name");
              localStorage.removeItem("position");
              localStorage.removeItem("checkCompany");
              this.router.navigateByUrl("/account/login");
            }
          }
        );
    });
  }
}
